<template>
  <div class="type">
    <div class="MessageBox">
      <div  class="FormBox">
        <div class="FileLinkMan BoxStyle">
          <div class="title">文件联系人：</div>
          <div class="titleVal">{{ InfoturesTypeRejectListData.fileContact.FileLinkMan }}</div>
        </div>
        <div class="FileLinkTel BoxStyle">
          <div class="title">文件联系人电话：</div>
          <div class="titleVal">{{ InfoturesTypeRejectListData.fileContact.FileLinkTel }}</div>
        </div>
        <div class="FileEMail BoxStyle">
          <div class="title">文件联系人邮箱：</div>
          <div class="titleVal">{{ InfoturesTypeRejectListData.fileContact.FileEMail }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">文件联系人地址：</div>
          <div class="titleVal">{{ InfoturesTypeRejectListData.fileContact.FileReceiveAddress }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import FilesAndPictures from '@/components/FilesAndPictures.vue'
export default {
  components: {
    FilesAndPictures
  },
  props: {
    InfoturesTypeRejectListData: {
      type: Object
    },
   
  },
  data() {
    return {
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    imgShowClick(par) {
      this.$emit('imgShowClick', par)
    },
    See(par) {
      this.$emit('See', par)
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url("../index.less");
.MessageBox {
  width: 101%;
  // height: 500px;


  .BoxStyle {
    line-height: 32px;
    border-radius: 2px;
    border: 1px solid rgb(230 230 230);
    cursor: pointer;
    display: inline-block;
    position: relative;
    min-width: 250px;
    height: 32px;
    color: rgb(0 0 0);
    font-size: 12px;
    background-color: rgb(250 251 252);
    margin-top: 10px;
    margin-left: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .title {
      display: inline-block;
    }

    .titleVal {
      display: inline-block;
    }
    
  }
  .FormBox{

        border-bottom: 1px solid rgb(230 230 230);
    padding-bottom: 10px;

    }
}
</style>